import React, { ReactElement } from "react";
import { NavLink } from "react-router-dom";
import { Image } from "semantic-ui-react";
import Logo from "assets/Logo.svg";

import { Container } from "./styled";

export default function Resources(): ReactElement {
  return (
    <Container data-testid="navigation">
      <Image src={Logo} verticalAlign="middle" circular />
      <NavLink
        exact
        to="/"
        isActive={(_, { pathname }) =>
          pathname === "/" || pathname.includes("/search/")
        }
      >
        PDF Resources
      </NavLink>
      <NavLink to="/acs-outlines">ACS Outlines</NavLink>
    </Container>
  );
}
